import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type ARQIconProps = {
  size?: number
}

export const ARQIcon: FunctionComponent<ARQIconProps> = ({ size = 35 }) => {
  const { height, width } = resize({ height: 35, size, width: 27 })

  return (
    <Svg {...{ viewBox: '0 0 27 34', width, height }}>
      <Path
        fill="#737373"
        fillRule="evenodd"
        d="M15.838 0H3.333A3.333 3.333 0 0 0 0 3.333V30a3.333 3.333 0 0 0 3.333 3.333h20A3.334 3.334 0 0 0 26.667 30V10.828a2 2 0 0 0-.586-1.414L17.253.586A2 2 0 0 0 15.838 0Zm.829 11.667H15V3.333l8.333 8.334h-6.666Z"
        clipRule="evenodd"
      />
      <Path
        fill="#fff"
        d="M7.47 21.761 5.75 27H4.367l2.348-6.32h.881l-.126 1.081ZM8.896 27l-1.723-5.239-.139-1.08h.89L10.286 27H8.897Zm-.078-2.352v1.02H5.482v-1.02h3.337Zm2.32-3.967h2.357c.483 0 .898.072 1.245.217.35.144.62.358.808.642.188.284.282.632.282 1.046 0 .338-.058.63-.174.872-.113.24-.273.442-.482.604-.205.159-.447.286-.725.382l-.412.217H11.99l-.01-1.016h1.524c.229 0 .418-.04.569-.122a.796.796 0 0 0 .338-.338c.079-.145.118-.313.118-.504 0-.202-.038-.377-.113-.525a.761.761 0 0 0-.343-.338 1.266 1.266 0 0 0-.577-.117H12.44V27h-1.302v-6.32ZM14.672 27l-1.441-2.817 1.376-.009 1.458 2.765V27h-1.393Zm5.861-.938 1.71 1.355-.82.711-1.684-1.354.794-.712Zm1.754-2.37v.3c0 .48-.066.912-.196 1.294a2.753 2.753 0 0 1-.55.976c-.241.266-.525.47-.852.612a2.71 2.71 0 0 1-1.089.213c-.396 0-.76-.071-1.09-.213a2.43 2.43 0 0 1-.854-.612 2.86 2.86 0 0 1-.56-.976 3.996 3.996 0 0 1-.196-1.294v-.3c0-.483.066-.914.196-1.293a2.9 2.9 0 0 1 .555-.976c.238-.27.521-.475.85-.617a2.73 2.73 0 0 1 1.09-.212c.4 0 .763.07 1.09.212.33.142.615.348.855.617s.425.594.555.976c.13.38.196.81.196 1.294Zm-1.316.3v-.308c0-.336-.031-.63-.095-.885a1.918 1.918 0 0 0-.27-.643 1.129 1.129 0 0 0-.429-.39 1.241 1.241 0 0 0-.586-.135c-.22 0-.415.045-.586.135-.17.086-.314.217-.43.39a1.981 1.981 0 0 0-.264.643c-.06.254-.091.55-.091.885v.308c0 .333.03.628.09.886.062.254.15.47.266.646a1.2 1.2 0 0 0 .434.395c.173.09.37.135.59.135.22 0 .414-.045.582-.135.17-.09.314-.221.43-.395.118-.176.208-.392.268-.646.061-.258.091-.553.091-.886Z"
      />
    </Svg>
  )
}
